/** import package [start] */
import axios, { AxiosInstance } from 'axios';
import Urls from './util';

const apiBackendInstance: AxiosInstance = axios.create({
  baseURL: Urls.getBackendUrl(),
});
export default apiBackendInstance;